import React from 'react';
import PropTypes from 'prop-types';
import { UnmountClosed } from 'react-collapse';
import { presets } from 'react-motion';

import RadioButton from '@style-guide/components/RadioButton';

import Arrow from './shared/Arrow';
import Body from './shared/Body';
import Header from './shared/Header';
import Title from './shared/Title';
import Wrapper from './shared/Wrapper';

import OtherResourcesFilter from './OtherResourcesFilter';
import PracticeAreaFilter from './PracticeAreaFilter';

class PracticeAreaOtherResourcesFilter extends React.Component {
  constructor() {
    super();

    this.state = {
      isOpened: true,
    };

    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse() {
    this.setState(prevState => ({
      isOpened: !prevState.isOpened,
    }));
  }

  render() {
    const {
      filterAppendOrRemove,
      otherResourcesValue,
      otherResourcesOptions,
      practiceAreaOptions,
      practiceAreasValue,
      filterUpdate,
      typeValue,
    } = this.props;

    const { isOpened } = this.state;

    return (
      <div>
        <Wrapper>
          <Header
            onClick={this.toggleCollapse}
            $isOpened={isOpened}
            id="practiceAreaOtherResourceFilterCollapseToggle"
          >
            <Title>Type</Title>
            <Arrow isOpened={isOpened} />
          </Header>
          <UnmountClosed
            presets={presets.gentle}
            isOpened={isOpened}
          >
            <Body
              id="filterPracticeAreaOtherResourceWrapper"
            >
              <RadioButton
                label="All Content"
                value="All Content"
                onChange={() => {
                  filterUpdate('otherResources', []);
                  filterUpdate('practiceAreas', []);
                  filterUpdate('type', 'all');
                }}
                id="filterPracticeAreaOtherResourceOptionAll"
                isChecked={typeValue === 'all'}
                name="All Content"
              />
              <RadioButton
                label="Practice Areas"
                value="Practice Areas"
                onChange={() => {
                  filterUpdate('otherResources', []);
                  filterUpdate('type', 'practiceAreas');
                }}
                id="filterPracticeAreaOtherResourceOptionPracticeAreas"
                isChecked={typeValue === 'practiceAreas'}
                name="Practice Areas"
              />
              <RadioButton
                label="Other Areas of Interest"
                value="Other Resources"
                onChange={() => {
                  filterUpdate('practiceAreas', []);
                  filterUpdate('type', 'otherResources');
                }}
                id="filterPracticeAreaOtherResourceOptionOtherResources"
                isChecked={typeValue === 'otherResources'}
                name="Other Resources"
              />
            </Body>
            {typeValue === 'practiceAreas' && (
              <PracticeAreaFilter
                filterAppendOrRemove={filterAppendOrRemove}
                filterValue={practiceAreasValue}
                $filterOptions={practiceAreaOptions}
                filterUpdate={filterUpdate}
                noCollapse
              />
            )}
            {typeValue === 'otherResources' && (
              <OtherResourcesFilter
                filterAppendOrRemove={filterAppendOrRemove}
                filterValue={otherResourcesValue}
                filterOptions={otherResourcesOptions}
                filterUpdate={filterUpdate}
                noCollapse
              />
            )}
          </UnmountClosed>
        </Wrapper>
      </div>
    );
  }
}

PracticeAreaOtherResourcesFilter.propTypes = {
  filterAppendOrRemove: PropTypes.func.isRequired,
  otherResourcesValue: PropTypes.arrayOf(PropTypes.object),
  otherResourcesOptions: PropTypes.arrayOf(PropTypes.object),
  practiceAreasValue: PropTypes.arrayOf(PropTypes.object),
  practiceAreaOptions: PropTypes.arrayOf(PropTypes.object),
  filterUpdate: PropTypes.func.isRequired,
  typeValue: PropTypes.string.isRequired,
};

PracticeAreaOtherResourcesFilter.defaultProps = {
  otherResourcesValue: [],
  otherResourcesOptions: [],
  practiceAreasValue: [],
  practiceAreaOptions: [],
};

PracticeAreaOtherResourcesFilter.displayName = 'PracticeAreaOtherResourcesFilter';

export default PracticeAreaOtherResourcesFilter;
